import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { EMPLOYEE_MY_DATA_DOWNLOAD_BONUS } from 'src/constants/EndpointUrls';
import SearchReactSelect from 'src/components/SearchReactSelect';

import ActionButton from 'jbc-front/components/ActionButton';
import { Task } from 'jbc-front/components/icons';
import PreviewPdfModalContainer from 'src/containers/PreviewPdfModalContainer';

import styles from './BonusActionSection.scss';

const fullName = employee => `${employee.lastName} ${employee.firstName}`;

class BonusActionSection extends React.Component {
  state = {
    isPdfPreview: false
  };

  showPreview = () => {
    this.setState({ ...this.state, isPdfPreview: true });
  };

  hidePreview = () => {
    this.setState({ ...this.state, isPdfPreview: false });
  };

  render() {
    const { selectingBonusId, allBonus, changeSelectingEmployeeBonus, bonus, client, employee } = this.props;
    return (
      <div>
        <div className={styles.wrap}>
          <div className={styles.action}>
            <SearchReactSelect
              value={selectingBonusId}
              options={allBonus}
              onChange={selected => changeSelectingEmployeeBonus(selected.value)}
              size="large"
              cache={false}
            />
            <ActionButton primary icon={<Task size={15} />} onClick={this.showPreview} className={styles.button}>
              PDF出力
            </ActionButton>
            <PreviewPdfModalContainer
              header="賞与明細"
              isOpen={this.state.isPdfPreview}
              hideModal={this.hidePreview}
              url={`${EMPLOYEE_MY_DATA_DOWNLOAD_BONUS}?id=${selectingBonusId}`}
            />
          </div>
          <div className={styles.summary}>
            <div className={styles.title}>{moment(bonus.payOn).format('YYYY年MM月')}賞与明細</div>
            <div className={styles.date}>支給日: {moment(bonus.payOn).format('YYYY年MM月DD日')}</div>
            <dl className={styles.user}>
              <dt>スタッフコード</dt>
              <dd>: {employee.staffCode}</dd>
            </dl>
            <dl className={styles.user}>
              <dt>氏名</dt>
              <dd>: {fullName(employee)}</dd>
            </dl>
            <div className={styles.client}>{client.name}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  client: state.currentClient.item.data
}))(BonusActionSection);
